"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routingKeys = void 0;
var routingKeys;
(function (routingKeys) {
    routingKeys["SEND_SMS_SUCCEEDED"] = "sendSmsSucceeded";
    routingKeys["SEND_SMS_FAILED"] = "sendSmsFailed";
    routingKeys["PATIENT_ONBOARDED"] = "patientOnboarded";
    routingKeys["SCHEDULE_TASK"] = "scheduleTask";
    routingKeys["PUBLISH_TASKS"] = "jobs.scheduler.publishTasks";
    routingKeys["REMOVE_FUTURE_INTERACTIONS"] = "removeFutureInteractions";
    routingKeys["SEND_PRIORITIZED_OUTREACH"] = "sendPrioritizedOutreach";
    routingKeys["PATIENT_DECLARED_AS_UNREACHABLE"] = "patientDeclaredAsUnreachable";
    routingKeys["PATIENT_DID_NOT_ANSWER"] = "patientDidNotAnswer";
    routingKeys["PATIENT_REMINDER_CALL_PERFORMED"] = "patientReminderCallPerformed";
    routingKeys["PATIENT_SUPPORT_CALL_PERFORMED"] = "patientSupportCallPerformed";
    routingKeys["PATIENT_PCP_CONFIRMATION_CALL_PERFORMED"] = "patientPcpConfirmationCallPerformed";
    routingKeys["PATIENT_POST_TEST_CALL_PERFORMED"] = "patientPostTestCallPerformed";
    routingKeys["PATIENT_TEST_FAILED_CALL_PERFORMED"] = "patientTestFailedCallPerformed";
    routingKeys["SCHEDULE_CALL"] = "scheduleCall";
    routingKeys["PATIENT_UPDATED"] = "patientUpdated";
    routingKeys["UNLOCK_CALL"] = "unlockCall";
    routingKeys["CALL_PERFORMED"] = "callPerformed";
    routingKeys["SEND_LETTER"] = "sendLetter";
    routingKeys["SEND_LETTER_SUCCEEDED"] = "sendLetterSucceeded";
    routingKeys["SEND_LETTER_FAILED"] = "sendLetterFailed";
    routingKeys["UPDATE_FLOW_STATUS"] = "updateFlowStatus";
    routingKeys["FLOW_STATUS_UPDATED"] = "flowStatusUpdated";
    routingKeys["PATIENT_CONSENTED"] = "patientConsented";
    routingKeys["TEST_FAILED"] = "testFailed";
    routingKeys["TEST_COMPLETED"] = "testCompleted";
    routingKeys["KIT_ACCEPTED_BY_PROVIDER"] = "kitAcceptedByProvider";
    routingKeys["SEND_KIT"] = "sendKit";
    routingKeys["SEND_KIT_VIA_KLC"] = "sendKitViaKlc";
    routingKeys["SEND_EMAIL"] = "sendEmail";
    routingKeys["SEND_EMAIL_SUCCEEDED"] = "sendEmailSucceeded";
    routingKeys["SEND_EMAIL_FAILED"] = "sendEmailFailed";
    routingKeys["EMAIL_OPENED"] = "emailOpened";
    routingKeys["SEND_SMS"] = "sendSms";
    routingKeys["PATIENT_CREATED"] = "patientCreated";
    routingKeys["PATIENT_FLOW_STATUS_CREATED"] = "patientFlowStatusCreated";
    routingKeys["RUN_COMMANDS"] = "runCommands";
    routingKeys["COMMUNICATION_PREFERENCE_UPDATED"] = "communicationPreferenceUpdated";
    routingKeys["UPDATE_COMMUNICATION_PREFERENCE"] = "updateCommunicationPreference";
    routingKeys["NOTIFICATIONS_WORKER"] = "notifications-worker.create-notification";
    routingKeys["ENQUEUE_CALL"] = "enqueueCall";
    routingKeys["DEQUEUE_CALL"] = "dequeueCall";
    routingKeys["INCOMING_SMS_RECEIVED"] = "incomingSmsReceived";
    routingKeys["SFTP_WORKER_UPLOAD"] = "sftp-worker.upload";
    routingKeys["SFTP_WORKER_DOWNLOAD"] = "sftp-worker.download";
    routingKeys["APPEND_EVENT"] = "event-sink.appendEvent";
    routingKeys["ADDRESS_REJECTED"] = "addressRejected";
    routingKeys["HEARTBEAT"] = "heartbeat";
    routingKeys["START_PATIENT_END_OF_SERVICE_COMMUNICATION"] = "startPatientEndOfServiceCommunication";
    routingKeys["ONBOARD_PATIENT"] = "onboardPatient";
    routingKeys["REMOVE_SPECIFIC_FUTURE_INTERACTION"] = "removeSpecificFutureInteraction";
    routingKeys["CREATE_PATIENT"] = "createPatient";
    routingKeys["UPDATE_PATIENT"] = "updatePatient";
    routingKeys["ETL_FILE"] = "etlFile";
    routingKeys["CREATE_PATIENT_FAILED"] = "createPatientFailed";
    routingKeys["CREATE_PATIENT_REJECTED"] = "createPatientRejected";
    routingKeys["IMPORT_FILE"] = "importFile";
    routingKeys["SEND_PCP_EMAIL_SUCCEEDED"] = "sendPcpEmailSucceeded";
    routingKeys["SEND_PCP_EMAIL_FAILED"] = "sendPcpEmailFailed";
    routingKeys["PCP_EMAIL_OPENED"] = "pcpEmailOpened";
    routingKeys["SEND_PCP_FAX_REQUEST"] = "sendPcpFaxRequest";
    routingKeys["SEND_PCP_FAX_SUCCEEDED"] = "sendPcpFaxSucceeded";
    routingKeys["SEND_PCP_FAX_FAILED"] = "sendPcpFaxFailed";
    routingKeys["TRANSFER_PATIENT_DATA"] = "transferPatientData";
    routingKeys["TRANSFER_ERASURE_REQUEST"] = "transferErasureRequest";
    routingKeys["CREATE_ERASURE_REQUEST"] = "createErasureRequest";
    routingKeys["GENERATE_IMPORT_REPORT"] = "generateImportReport";
    routingKeys["CREATE_PATIENT_NOTE"] = "createPatientNote";
    routingKeys["PATIENT_NOTE_CREATED"] = "patientNoteCreated";
    routingKeys["REQUEST_EXTERNAL_RX"] = "requestExternalRx";
    routingKeys["REQUEST_EXTERNAL_CONSULT"] = "requestExternalConsult";
    routingKeys["CREATE_PRE_APPROVAL"] = "createPreApproval";
    routingKeys["UPDATE_PRE_APPROVAL_STATUS"] = "updatePreApprovalStatus";
    routingKeys["UPDATE_RX_STATUS"] = "updateRxStatus";
    routingKeys["UPDATE_CONSULT_STATUS"] = "updateConsultStatus";
    routingKeys["PRE_APPROVAL_STATUS_UPDATED"] = "preApprovalStatusUpdated";
    routingKeys["UNTAG_AS_FOLLOW_UP_TEST_PATIENT"] = "untagAsFollowUpTestPatient";
    routingKeys["START_PATIENT_END_OF_FOLLOW_UP_SERVICE_COMMUNICATION"] = "startPatientEndOfFollowUpServiceCommunication";
    routingKeys["TAG_AS_FOLLOW_UP_TEST_PATIENT"] = "tagAsFollowUpTestPatient";
    routingKeys["RENEWAL_PATIENT_CREATED"] = "renewalPatientCreated";
    routingKeys["SEND_PUSH_NOTIFICATION"] = "sendPushNotification";
    routingKeys["SEND_PUSH_NOTIFICATION_SUCCEEDED"] = "sendPushNotificationSucceeded";
    routingKeys["SEND_PUSH_NOTIFICATION_FAILED"] = "sendPushNotificationFailed";
    routingKeys["UPDATE_PUSH_NOTIFICATION"] = "updatePushNotification";
    routingKeys["REMOVE_COHORT"] = "removeCohort";
    routingKeys["PATIENT_APP_DATA_UPDATED"] = "patientAppDataUpdated";
    routingKeys["PATIENT_DECLINED"] = "patientDeclined";
    routingKeys["PATIENT_UNAUTHORIZED"] = "patientUnauthorized";
    routingKeys["PATIENT_INELIGIBLE"] = "patientIneligible";
    routingKeys["START_PATIENT_ENGAGEMENT"] = "startPatientEngagement";
    routingKeys["CREATE_OPTED_OUT_PATIENT"] = "createOptedOutPatient";
    routingKeys["ERASURE_REQUEST_CREATED"] = "erasureRequestCreated";
    routingKeys["ORG_UNIT_UPDATED"] = "orgUnitUpdated";
    routingKeys["PARTNER_OFF_BOARDED"] = "partnerOffBoarded";
    routingKeys["OFF_BOARD_PATIENT"] = "offBoardPatient";
    routingKeys["END_PATIENT_SERVICE"] = "endPatientService";
    routingKeys["PATIENT_SERVICE_ENDED"] = "patientServiceEnded";
    routingKeys["ERASURE_REQUEST_FULFILLED"] = "erasureRequestFulfilled";
    routingKeys["PATIENT_DELETED"] = "patientDeleted";
    routingKeys["FILE_ENTRY_DELETED"] = "fileEntryDeleted";
    routingKeys["PROCESS_IMPORT_FILE_ENTRY"] = "processImportFileEntry";
    routingKeys["PATIENT_PROVIDED_WITH_KIT"] = "patientProvidedWithKit";
    routingKeys["DISABLE_PATIENT_ONBOARDING"] = "disablePatientOnboarding";
    routingKeys["CREATE_RX"] = "createRx";
    routingKeys["PATIENT_UNSUBSCRIBED"] = "patientUnsubscribed";
    routingKeys["BLOCK_PATIENT_EMAIL"] = "blockPatientEmail";
    routingKeys["PARTNER_UPDATED"] = "partnerUpdated";
    routingKeys["PATIENT_APP_VERIFIED"] = "patientAppVerified";
    routingKeys["PATIENT_KIT_NOT_DELIVERED"] = "patientKitNotDelivered";
    routingKeys["INITIATE_PATIENT_TEST"] = "initiatePatientTest";
    routingKeys["PATIENT_NEXT_VISIT_SCHEDULED"] = "patientNextVisitScheduled";
    routingKeys["PARTNER_CREATED"] = "partnerCreated";
    routingKeys["PROCESS_ALGO_RECOMMENDATION"] = "processAlgoRecommendation";
    routingKeys["SMS_STATUS_UPDATED"] = "smsStatusUpdated";
    routingKeys["READ_ALGO_RECOMMENDATIONS_FILE"] = "readAlgoRecommendationsFile";
    routingKeys["UPDATE_CYCLE_SUMMARY"] = "updateCycleSummary";
    routingKeys["PATIENT_RENEWED"] = "patientRenewed";
    routingKeys["PATIENT_REJECTED_COMMUNICATION_CREATED"] = "patientRejectedCommunicationCreated";
    routingKeys["BULK_DELETE_RECORDS_FROM_EXTERNAL_VENDOR"] = "bulkDeleteRecordsFromExternalVendor";
    routingKeys["PCP_CONFIRMED"] = "pcpConfirmed";
    routingKeys["PCP_CONFIRMATION_STATUS_CHANGED"] = "pcpConfirmationStatusChanged";
    routingKeys["SEND_RESULTS_SFTP_UPLOAD_COMPLETE"] = "sendResultsSftpUploadComplete";
    routingKeys["SEND_RESULTS_SFTP_DOWNLOAD_COMPLETE"] = "sendResultsSftpDownloadComplete";
    routingKeys["SEND_RESULTS_NEXT_FLOW"] = "sendResultsNextFlow";
    routingKeys["START_POST_TEST_FLOW"] = "startPostTestFlow";
    routingKeys["ABORT_POST_TEST_FLOW"] = "abortPostTestFlow";
    routingKeys["ORDER_BLOCKED"] = "orderBlocked";
    routingKeys["SMS_SENT"] = "smsSent";
    routingKeys["FREE_TEMPORARILY_SUSPENDED_CALLS"] = "freeTemporarilySuspendedCalls";
    routingKeys["REJECT_COMMUNICATION"] = "rejectCommunication";
    routingKeys["SMS_DELAYED"] = "smsDelayed";
    routingKeys["PATIENT_INCOMPLETE_CALL"] = "patientIncompleteCall";
    routingKeys["START_TRACKING_PACKAGE"] = "startTrackingPackage";
})(routingKeys || (exports.routingKeys = routingKeys = {}));
